import { BehaviorSubject } from 'rxjs';
import type { MapLayer } from '../api/map-layers.api';

function createMapLayersService() {
  const layers$ = new BehaviorSubject<MapLayer[]>([]);
  const visible$ = new BehaviorSubject<Record<string, boolean>>({});

  function setLayers(layers: MapLayer[]) {
    layers$.next(layers);
    const current = visible$.value;
    const next: Record<string, boolean> = {};
    for (const l of layers) {
      next[l.id] = current[l.id] ?? true;
    }
    visible$.next(next);
  }

  function toggle(id: string) {
    visible$.next({ ...visible$.value, [id]: !visible$.value[id] });
  }

  return { layers$, visible$, setLayers, toggle };
}

export const mapLayersService = createMapLayersService();
